'use strict';
angular.module('TurneroApp').component('coTramitesOnline', {
	bindings: {
		usuario: '<',
	},
    controller: ['$window', 'turnosService', '$state', '$rootScope', 'portal', 'tramiteService', 'utilsService', 'appExternaService', 'agendaService', '$mdDialog', 'agendasBloqueadasService', 'miDoctaModoService',
        function ($window, turnosService, $state, $rootScope, portal, tramiteService, utilsService, appExternaService, agendaService, $mdDialog, agendasBloqueadasService, miDoctaModoService) {
		 	var ctrl = this;

		 	ctrl.loading = true;
			ctrl.layoutState = $state.$current.name.split('.')[0];
			ctrl.urlHome = ctrl.layoutState === 'ciudadanoPortal' ? 'turnosPortal' : 'turnos';

			ctrl.organismoVisible = function (tramite) {
				var nombre = tramite && tramite.N_Unidad_Tramite;
				if (nombre && String(nombre).trim()) {
					return nombre;
				}
				return 'Sin organismo';
			};

			ctrl.urlGuiaTramite = function (tramite) {
				if (tramite && tramite.Id_Ref_Guia_Tramites_Municipal) {
					return 'https://guiadetramites.cordoba.gob.ar/#/tramite/' + tramite.Id_Ref_Guia_Tramites_Municipal;
				}
				return 'https://guiadetramites.cordoba.gob.ar/#/';
			};

			ctrl.idCentroFiltro = function () {
				return $rootScope.Id_Centro_Atencion === undefined ? null : $rootScope.Id_Centro_Atencion;
			};

			ctrl.buscar = function () {
				ctrl.query.page = 1;
				ctrl.cargarGrilla({ silencioso: true });
			};

			ctrl.regresar = function ($event) {
				if ($event) {
					$event.preventDefault();
				}

				$rootScope.$broadcast('esHome', false);
				$rootScope.$broadcast('esCalendario', false);
				$rootScope.$broadcast('esTasaRetributiva', false);

				if (ctrl.layoutState === 'ciudadano') {
					if ($rootScope.btnConoceCentro) {
						// Camino: alternativa -> centros -> tramites.
						// Se conserva el centro elegido para volver al listado anterior.
						$state.go(ctrl.layoutState + '.centrosatencion');
						return;
					}

					$rootScope.Id_Centro_Atencion = null;
					$state.go(ctrl.layoutState + '.tramitealternativa');
					return;
				}

				// Los accesos por portal no tienen pantalla de alternativa.
				$rootScope.$broadcast('esHome', true);
				$rootScope.btnConoceCentro = false;
				$rootScope.Id_Centro_Atencion = null;
				$window.location.href = miDoctaModoService.estaActivo()
					? miDoctaModoService.urlInternaConModo('/turnos')
					: ctrl.urlHome + '/';
			};

		 	ctrl.limpiarMemoria = function () {
		 		$rootScope.$broadcast('esHome', false);
                $rootScope.$broadcast('esCalendario', false);
                $rootScope.$broadcast('esTasaRetributiva', false);
		 		ctrl.cargarGrilla();
            }
            ctrl.limpiarDatosAPIExterna = function () {
				ctrl.Agenda.APILink = null;
				ctrl.Agenda.Respuesta = null;
			}
		 	ctrl.$onChanges = function () {
		 		if (ctrl.usuario) {
		 			ctrl.limpiarMemoria();
		 		}
		 	};

		 	ctrl.limitOptions = [10, 25, 50, 75, 100, {
		 		label: 'Todos',
		 		value: function () {
		 			return ctrl.pagination.total;
		 		}
		 	}];

		 	ctrl.query = {
		 		limit: 3,
		 		page: 1,
		 		filter: ''
		 	};

		 	//Se inicializa en null para que al principio no tome que no hay valores
		 	ctrl.pagination = {
		 		total: null
		 	};

            ctrl.cargarGrilla = function (opts) {
                if ($rootScope.btnConoceCentro === undefined || $rootScope.btnConoceCentro === null) {
                    //regresar a la pantalla principal
                    //$window.location.href = './turnos';
                    $state.go('ciudadano.tramitealternativa');
                }

				var silencioso = opts && opts.silencioso;
				if (!silencioso) {
					ctrl.loading = true;
				}
                tramiteService.Get_Online({
                    'filtro.Id_Centro_Atencion': ctrl.idCentroFiltro(),
		 			'filtro.Texto': ctrl.query.filter,
		 			'filtro.Nro_Pagina': ctrl.query.page,
		 			'filtro.Tam_Pagina': ctrl.query.limit
		 		}, function (resultado) {
		 			ctrl.Tramites = resultado.Data;
		 			ctrl.pagination.total = Math.ceil(resultado.Paging.Reg_Totales / ctrl.query.limit);
		 			ctrl.loading = false;
		 			swal.close();
		 		}, function (error) {
		 			ctrl.loading = false;
		 			swal.close();
		 		})
		 	};


		 	ctrl.seleccionarTramite = function (tramite) {
		 		// Validar si el trámite está bloqueado (validación inicial antes de obtener agendas)
		 		// Validamos solo por trámite ya que aún no tenemos el ID de agenda
		 		try {
		 			var mensajeBloqueoTramite = agendasBloqueadasService.obtenerMensajeBloqueo(null, tramite.Id_Tramite);
		 			if (mensajeBloqueoTramite) {
		 			swal({
		 				title: 'Atención',
		 				html: mensajeBloqueoTramite,
		 				type: 'warning',
		 				allowEscapeKey: false,
		 				allowOutsideClick: false,
		 				confirmButtonColor: '#004b81',
		 				confirmButtonText: "Aceptar",
		 			});
		 			return; // No permitir avanzar
		 			}
		 		} catch (error) {
		 			// Error silencioso, continuar con el flujo normal
		 		}
		 		
		 		if (!tramite.Id_Tramite_Aplicacion) {
					if(tramite.Ids_Tramites_Requeridos.length > 1) {
						utilsService.swalTitle('Cargando', 'info');
						tramiteService.Validar_Requerimientos({ 'Id_Tramite_Relevado': tramite.Id_Tramite }).$promise.then(function (response) {
							if (response && response.Data) {
								swal({
									title: 'No es posible continuar',
									html: response.Data,
									type: 'warning',
									allowEscapeKey: false,
									allowOutsideClick: false,
									confirmButtonColor: '#e77a1e',
									confirmButtonText: "Aceptar",
								})
							} else {
								ctrl.irACentros(tramite);
							}
						})
					} else {
						ctrl.irACentros(tramite);
					}
                } else {
                    
		 			appExternaService.Traer_URL_Aplicacion_Ext({ 'Id_Tramite_Aplicacion': tramite.Id_Tramite_Aplicacion }).$promise.then(function (app_result) {
		 				var resultado = app_result.Data;
		 				if (resultado && resultado.Recordatorio) {
		 					swal({
		 						title: 'Atención',
		 						text: resultado.Recordatorio,
		 						type: 'info',
		 						confirmButtonColor: '#3085d6',
		 						confirmButtonText: 'Ok',
		 						showCancelButton: true,
		 						allowEscapeKey: false,
		 						allowOutsideClick: false,
		 						cancelButtonColor: 'red',
		 						cancelButtonText: 'Cancelar'
		 					}).then((result) => {
		 						if (result) {
		 							if (resultado.Url_Aplicacion) {
		 								if (miDoctaModoService.estaActivo()) {
		 									swal({
		 										title: 'Acción no disponible en Mi Docta',
		 										html: 'Este trámite continúa en otro sitio externo. Para finalizarlo, ingresá a Turnero por fuera de Mi Docta.',
		 										type: 'info',
		 										confirmButtonColor: '#004b81',
		 										confirmButtonText: 'Aceptar'
		 									});
		 								} else {
		 									window.location.href = resultado.Url_Aplicacion;
		 								}
		 							} else {
		 								ctrl.irACentros(tramite);
		 							};
		 						};
		 					}).catch(function (error) {
		 						swal.close();
		 						if (error != "cancel") {
		 							utilsService.errores(error);
		 						}

		 					})
		 				} else {
		 					ctrl.irACentros(tramite);
		 				}
		 			}).catch(function (error) {
		 				swal.close();
		 				utilsService.errores(error);
		 			});

		 		}
		 	}
			 
			 ctrl.irACentros = function (tramite) {
				 tramite.Id_Tramite_Relevado = tramite.Id_Tramite;
				 if (!$rootScope.btnConoceCentro) {//si no conoce el centro debe ir a bucar el centro del tramite
                    $rootScope.$broadcast('seleccionarTramite', tramite);
                    $state.go('ciudadano.centrosatencion');
                } else {//si conoce el centro debe ir a la agenda
                    $rootScope.$broadcast('seleccionarTramite', tramite, false);
                    utilsService.swalTitle('Cargando Agendas', 'info');
					agendaService.Get_Info_API({'id_tramite_relevado': tramite.Id_Tramite}).$promise.then(function (datosApi) {
						ctrl.Agenda = datosApi;
						if(ctrl.Agenda.APILink != "" && ctrl.Agenda.Respuesta != "Iniciado")
						{
                            if (ctrl.Agenda.Respuesta && ctrl.Agenda.Respuesta.includes("_ADV")) {
                                swal({
                                    title: 'Atención',
									html: '¡Hemos detectado que Usted tiene un trámite de MI LICENCIA DIGITAL en curso!<br><br>Para retirar su licencia de conducir tramitada por la vía digital <a href="' + portal.getUrlServer() + 'turnos?tramitePortal=' + ctrl.Agenda.IdTramiteDigital + '">ingrese aquí</a>.<br><br>El trámite para el que está intentando sacar turno es \"' + tramite.N_Tramite + '\".<br><br>Por favor verifique que este trámite sea el que necesita.',
                                    type: 'warning',
                                    allowEscapeKey: false,
                                    allowOutsideClick: false,
                                    confirmButtonColor: '#004b81',
                                    confirmButtonText: "Aceptar",
                                }).then(function () {
									ctrl.mostrarAgenda(tramite);
                                })
                            }
                            else
                            {
								swal({
									title: 'Atención',
									text: 'El tramite solicitado no esta disponible porque no tiene finalizada su gestión de licencia de conducir OnLine',
									type: 'warning',
									allowEscapeKey: false,
									allowOutsideClick: false,
									confirmButtonColor: 'rgb(48, 133, 214)',
									confirmButtonText: "Aceptar",
								}).then(function () {
									$window.location.href = miDoctaModoService.urlInternaConModo('/turnos');
								})
                                ctrl.limpiarDatosAPIExterna();
                            }
						}
                        else
                        {
                            ctrl.mostrarAgenda(tramite);
                        }
					}).catch(function (error) {
						if (miDoctaModoService.estaActivo()) {
							ctrl.mostrarAgenda(tramite);
							return;
						}
                        swal({
							title: 'Atención',
							text: 'Por un problema ajeno a esta plataforma, no hemos podido validar si posee un tramite de licencia online finalizado. Por favor vuelva a intentarlo mas tarde.',
							type: 'warning',
							allowEscapeKey: false,
							allowOutsideClick: false,
							confirmButtonColor: '#004b81',
							confirmButtonText: "Aceptar",
						}).then(function () {
							$window.location.href = miDoctaModoService.urlInternaConModo('/turnos');
							})
                    });
					
                }
            };

			ctrl.mostrarAgenda = function (tramite) {
				var idCentro = $rootScope.Id_Centro_Atencion;
				if (idCentro === undefined || idCentro === null) {
					$rootScope.$broadcast('seleccionarTramite', tramite);
					$state.go('ciudadano.centrosatencion');
					return;
				}
				agendaService.Get_x_Centro_Modalidad({ 'id_centro_atencion': idCentro, 'id_tramite_relevado': tramite.Id_Tramite, 'id_modalidad': 2/*ctrl.Modalidades.OnLine*/ }).$promise.then(function (resultado) {
					swal.close();
					ctrl.Agenda = resultado.Data;
					
					// Filtrar agendas bloqueadas
					var agendasBloqueadas = [];
					ctrl.Agenda = ctrl.Agenda.filter(function (agenda) {
						var idAgenda = agenda.id || agenda.Id_Agenda || agenda.id_agenda;
						var mensajeBloqueo = agendasBloqueadasService.obtenerMensajeBloqueo(idAgenda, tramite.Id_Tramite);
						if (mensajeBloqueo) {
							agendasBloqueadas.push({ agenda: agenda, mensaje: mensajeBloqueo });
							return false; // Excluir esta agenda
						}
						return true; // Incluir esta agenda
					});
					
					// Mostrar warning si hay agendas bloqueadas (solo una vez)
					if (agendasBloqueadas.length > 0) {
						swal({
							title: 'Atención',
							html: agendasBloqueadas[0].mensaje,
							type: 'warning',
							allowEscapeKey: false,
							allowOutsideClick: false,
							confirmButtonColor: '#004b81',
							confirmButtonText: "Aceptar",
						});
					}
					
					if (ctrl.Agenda.length == 1) {
						$rootScope.$broadcast('seleccionarAgenda', ctrl.Agenda[0], ctrl.Agenda);
						$rootScope.$broadcast('esCalendario', true);
						$state.go(ctrl.layoutState + '.calendario');
					} else if (ctrl.Agenda.length > 1) {
						$mdDialog.show({
							template: require('./modalSeleccioneAgenda.html'),
							parent: angular.element(document.body),
							clickOutsideToClose: true,
							fullscreen: false, // Only for -xs, -sm breakpoints.,
							controllerAs: '$ctrl',
							controller: function () {
								return ctrl;
							}
						});
					} else if (agendasBloqueadas.length === 0) {
						sweetAlert("No hay agendas disponibles", 'Actualmente no hay agendas disponibles para este centro de atención. <br/> Inténtelo nuevamente con otro.', "warning");
					}
				}).catch(function (error) {
					swal.close();
				})
			};

            ctrl.cerrarModal = function () {
                $mdDialog.destroy();
            };

            ctrl.cambiarAgenda = function (agenda) {
                if (ctrl.agendaSeleccionada != null && ctrl.agendaSeleccionada != undefined) {
                    // Validar si la agenda seleccionada está bloqueada
                    var idAgenda = ctrl.agendaSeleccionada.id || ctrl.agendaSeleccionada.Id_Agenda;
                    var idTramite = ctrl.Tramite ? (ctrl.Tramite.Id_Tramite || ctrl.Tramite.Id_Tramite_Relevado) : null;
                    var mensajeBloqueo = agendasBloqueadasService.obtenerMensajeBloqueo(idAgenda, idTramite);
                    
                    if (mensajeBloqueo) {
                        // Mostrar warning y no permitir avanzar
                        swal({
                            title: 'Atención',
                            html: mensajeBloqueo,
                            type: 'warning',
                            allowEscapeKey: false,
                            allowOutsideClick: false,
                            confirmButtonColor: '#004b81',
                            confirmButtonText: "Aceptar",
                        });
                        return; // No avanzar
                    }
                    
                    $rootScope.$broadcast('seleccionarAgenda', ctrl.agendaSeleccionada, ctrl.Agenda);
                    ctrl.cerrarModal();
                    $rootScope.$broadcast('esCalendario', true);
                    $state.go(ctrl.layoutState + '.calendario');
                } else {
                    sweetAlert("Debe seleccionar una agenda de las opciones", '', "warning");
                }
            }

		 }],
	template: require('./turnoOnlineTramite.html')
});



// WEBPACK FOOTER //
// ./app/components/turnos/turnosOnline/turnoOnlineTramiteComponent.js